<template>
  <div>
    <!-- <el-card body-style="width:100%; padding:20px;display:flex;align-items: center;justify-content:center" shadow="always">
      <i class="material-icons" style="margin-right:4px; color:#fa0;width:28px;">location_on</i>
      <div class='highlight-1'><a href="https://goo.gl/maps/o2mKgePJeHo" target="_blank" style="text-decoration:none;color:#303030">2721 S Halsted St, Chicago, IL, 60608</a></div>
    </el-card> -->
    <div class="inner-box" v-show="!user.adminUser">
      <div class="inner-left">
        <el-card shadow="always" v-for="item in stores" :key="item.mapIndex" style="margin-bottom: 20px;">
          <div class="highlight-1">{{ item.name }}</div>
          <div style="margin-top:6px;">
            <a class="content" :href="`tel:${item.shippingAddress.phone}`" style="width: 100%; text-align: left; margin-top: 12px;">
              <i class="material-icons" style="">local_phone</i>+1 {{item.phoneStr}}
            </a>
            <!-- <a class="content" href="mailto:yundaexchicago@gmail.com" style="width: 100%; text-align: left; margin-top: 12px;">
              <i class="material-icons">email</i>yundaexchicago@gmail.com
            </a> -->
            <div class="content" style="width: 100%; text-align: left; margin-top: 12px;">
              <i class="material-icons">access_time</i>{{ item.officeHourStrEn }}</div>
            <div class="content" style="width: 100%; text-align: left; margin-top: 12px;">
              <i class="material-icons">location_on</i>{{ item.addressStr }}</div>
          </div>
        </el-card>
        <div style="height:16px;background-color: transparent"></div>
        <!-- <el-card shadow="always">
          <div class="highlight-1">Leave Us A Message</div>
          <div style="display:flex;flex-direction:column;margin-top:8px;">
            <el-form label-position="top" label-width="100px" :model="leaveMessage" :rules="rules" ref="submitMessage">
              <el-form-item label="Name" prop="name">
                <el-input v-model="leaveMessage.name" ></el-input>
              </el-form-item>
              <el-form-item label="Email" prop="email">
                <el-input v-model="leaveMessage.email"></el-input>
              </el-form-item>
              <el-form-item label="Message" prop="message">
                <el-input type="textarea" v-model="leaveMessage.message"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button type="primary" @click="submitForm" plain>Submit Message</el-button>
                </el-form-item>
            </el-form>
          </div>
        </el-card> -->
      </div>
      <!-- <div class="inner-right">
        <el-card shadow="always">
          <div class="highlight-1"><img src="../../public/images/timg.png" alt="wechat mini" width="28" style="margin-right:8px;"> Wechat Mini Program</div>
          <div style="display:flex;flex-direction:column;margin-top:12px;">
            <img src="../../public/images/yunda mini program.jpg" alt="yunda mini program" style="width:258px;margin:auto;">
            <div class="highlight1">Yunda芝加哥</div>
          </div>
        </el-card>
        <div style="height:16px;background-color: transparent"></div>
        <el-card body-style="padding:20px;" shadow="always">
          <div class="highlight-1">About</div>
          <div style="display:flex;flex-direction:column;margin-top:6px;position:relative">
            <div class="content" style="width: 100%">
              <el-table
              :data="tableFee"
              border
              style="width: 100%;white-space:pre-line">
                <el-table-column
                prop="shipping"
                label="Shipping">
                </el-table-column>
                <el-table-column
                prop="tax"
                label="Tax">
                </el-table-column>
                <el-table-column
                prop="insurance"
                label="Insurance"
                width="210px">
                </el-table-column>
                <el-table-column
                prop="packing"
                label="Packing">
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-card>
      </div> -->
    </div>
    <div v-show="user.adminUser" style="margin-top: 16px">
      <el-card>
        <el-table :data="displayMessages" style="width=100%;">
          <el-table-column
            prop="time"
            label="Time">
          </el-table-column>
          <el-table-column
            prop="status"
            label="Status"
            :filters="[{ text: 'Unread(未读)', value: 'Unread' }, { text: 'Read(已读)', value: 'Read' }]"
            :filter-method="filterStatus"
            filter-placement="bottom-end">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 'Unread' ? 'danger' : 'success'">{{scope.row.status}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="email"
            label="Email">
          </el-table-column>
          <el-table-column
            prop="message"
            label="Message"
            width="400">
          </el-table-column>
          <el-table-column
          fixed="right"
          label="Action">
            <template slot-scope="scope">
              <div>
                <el-tooltip content="Mark as READ" placement="bottom" effect="light">
                  <i class="material-icons" v-show="scope.row.status === 'Unread'" @click="changeMessageStatus(scope.row.stamp,'Read')" style="cursor: pointer;">drafts</i>
                </el-tooltip>
                <el-tooltip content="Mark as UNREAD" placement="bottom" effect="light">
                  <i class="material-icons" v-show="scope.row.status === 'Read'" @click="changeMessageStatus(scope.row.stamp,'Unread')" style="cursor: pointer;">markunread</i>
                </el-tooltip>
                <el-tooltip content="REPLY user through email" placement="bottom" effect="light">
                  <a :href="'mailto:' + scope.row.email + '?subject=Reply from YUNDA Chicago customer service.[' + scope.row.stamp.slice(-4) + ']&body=Dear customer'">
                    <i class="material-icons" @click="changeMessageStatus(scope.row.stamp,'Read')" style="cursor: pointer;">reply</i>
                  </a>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 24px; text-align: center;">
          Tip: If there is no message displayed, try resetting the status filter, or just refresh the page.
        </div>
        <div style="overflow: auto; margin-top: 2rem">
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page.sync="pageNum"
            :total="messages.length"
            :page-size="messagePerPage">
          </el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { leaveMessage, changeStatus } from '../../public/js/support'
import { db } from '../main'

export default {
  name: 'Support',
  props: ['user','stores'],
  data () {
    return {
      tableFee: [{
        shipping: '$3.5 / LB ( Except $5 / LB for 内蒙古自治区，新疆自治区，西藏自治区 )',
        tax: '11.2% of items price',
        insurance: 'Free（免费），如包裹丢失最高赔付$100\n$3, 如包裹丢失最高赔付$200\n$6, 如包裹丢失最高赔付$300\n$9, 如包裹丢失最高赔付$400',
        packing: '$1 / Packing Box'
      }],
      leaveMessage: {
        name: this.user.displayName,
        email: this.user.email,
        message: ''
      },
      rules: {
        name: [{ required: true, message: 'Please input your name', trigger: 'change' }],
        email: [
          { required: true, message: 'Please input your email', trigger: 'change' },
          { type: 'string', pattern: /\S+@\S+/, message: 'Please input a valid email address', trigger: 'change' }
        ],
        message: [{ required: true, message: 'Please input your message', trigger: 'change' }]
      },
      messages: [],
      pageNum: 1,
      messagePerPage: 50
    }
  },
  firestore: function () {
    return {
      messages: db.collection('message').orderBy('status', 'desc').orderBy('stamp', 'desc').limit(500)
    }
  },
  methods: {
    submitForm () {
      this.$refs['submitMessage'].validate((valid) => {
        if (valid) {
          return leaveMessage(this.leaveMessage).then(() => {
            // console.log('success')
            this.$message({
              message: 'We have received your message, you can expect a reply through your email later.',
              type: 'success'
            })
          }).catch(err => {
            // console.log(err)
            // console.log('send error info')
            this.$message({
              message: 'Sorry, we have a problem when sending your message, please try again.',
              type: 'error'
            })
          })
        } else {
          this.$message({
            message: 'Check the form before sending it.',
            type: 'warning'
          })
        }
      })
    },
    filterStatus (value, row) {
      return row.status === value
    },
    changeMessageStatus (stamp, status) {
      return changeStatus(stamp, status).then(() => {
        this.$message({
          message: 'Message status updated.',
          type: 'success'
        })
      }).catch(err => {
        // console.log(err)
        this.$message({
          message: 'Cannot set the status, please try again',
          type: 'warning'
        })
      })
    }
  },
  computed: {
    displayMessages: function () {
      let page = this.pageNum
      let start = (page - 1) * this.messagePerPage
      let end = page * this.messagePerPage
      let displayMessages = this.messages.slice(start, end)
      return displayMessages
    }
  }
}
</script>

<style>
.material-icons{
  color:#c0c0c0;
  width:24px;
  margin-right: 12px;
}
.inner-box {
  margin-top: 16px;
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.inner-left {
  width: 100%;
  margin-right: 8px;
}
.inner-right {
  width: 50%;
  margin-left:8px;
}
.highlight-1 {
  margin-top: 4px;
  font-size: 15px;
  font-family: Montserrat, sans-serif;
  text-align: left;
}
.highlight1 {
  margin-top: 16px;
  margin-bottom: 12px;
  font-size: 15px;
  font-family: Montserrat, sans-serif;
  text-align: center;
}
.content {
  color: rgba(0, 0, 0, 0.8);
  font-size: 15px;
  text-align: left;
  margin-top: 16px;
  display: flex;
  align-items: center;
  text-decoration: none;
}
.el-form-item {
  text-align: left;
}
.el-form--label-top .el-form-item__label {
  padding: 0
}
@media (max-width: 1023px) {
  .inner-box {
    margin-top: 16px;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .inner-left {
    width: 100%;
    margin-right: 0;
}
  .inner-right {
    margin-top: 16px;
    margin-left: 0;
    width: 100%;
  }
}
</style>
